export const lang = {
  companyName: '超电新能',
  /* 首页 */
  home: '首页',

  /* 关于我们 */
  about: '关于我们',
  corporateCulture: '企业文化',
  companyProfile: '企业简介',
  developmentHistory: '发展历程',
  productionOffice: '生产办公',
  cellProductionLine: '电芯产线',

  /* 产品系列 */
  productGroup: '产品系列',
  highRateCell: '高倍率电芯',
  batteryModule: '电池模组',

  /* 解决方案 */
  solutions: '解决方案',
  heavyTransport: '重载运输',
  logisticsFreight: '物流货运',
  cityDelivery: '城市配送',
  lightPassengerVehicle: '轻型乘用',
  highSpeedMotorcycle: '高速电摩',
  electricalTools: '电动工具',
  drone: '无人机',

  /* 创新技术 */
  technology: '创新技术',
  materialTechnology: '材料技术',
  structuralTechnology: '结构技术',
  cloudPlatform: '安全技术',

  /* 新闻 */
  news: '新闻资讯',

  /* 联系我们 */
  contactUs: '联系我们',
  talentRecruitment: '人才招聘',
  channelCooperation: '渠道合作',
  bidAnnouncement: '招标公告',



  privacyPolicyInformationSecurity: '隐私条款和信息安全',
  legalNote: '法律说明',

  homeText: "构建超级快充新场景",
  homeText1: "加电像加油一样",

  newsTitle: '新闻',
  checkMore: '查看更多',

  vision: '愿景',
  visionContent: '以超电动力驱动世界能源变革',
  mission: '使命',
  missionContent: '让超电的创新不止换取用户的能量无限',
  coreValue: '核心价值观',
  coreValueContent: '创新 &nbsp; 卓越 &nbsp; 诚信 &nbsp; 共赢',

  companyProfileContent: '江苏超电新能源科技发展有限公司立志成为全球领先的电池研发、智造企业。自2015年成立以来，一直专注于打造超级快充电池，为工程重卡、城市物流、轻型电动、家电工具等多个行业提供分钟级超级快充电池及应用解决方案，是市场上唯一实现规模化运营的分钟级超级快充系统方案供应商。',
  historyList2015: '超电新能源在无锡成立',
  historyList2016: '天使轮融资',
  historyList2017: '成立山东超电投资新建3.5GWh产线',
  historyList2018: '超级快充行业应用示范全国推广',
  historyList2021: '山东产线一期建成投产及二期产线规划设计',
  historyList2022: '全国五大产区产线规划及山东产线二期建成投产',

  previous:'上一页',
  next: '下一页',

  loopLife: '循环寿命',
  energyDensity: '能量密度',
  workTemp: '工作温度',
  standardVol: '标称电压',
  chargeRate: '充电倍率',
  dischargeRate: '放电倍率',

  platformDevelop: '平台化开发',
  moduleFreeSet: '模组自由配置',
  highRate: '超高倍率',
  highHengLiu: '超高恒流率',
  highLoopLife: '长循环寿命',
  highTempRange: '充电宽温区',
  highPower: '高能量密度',

  heavyCarContent: '超电动力电池为重载运输车辆提供澎湃动力，满足工地、矿场、港口、道路工程建设等多种复杂工况需求，大大节约充电时间，降低单位使用成本，提升运营效率，为减少燃油碳排放提供切实可行的高效应用场景解决方案。',
  huoCheContent: '超电动力电池产品具备高安全、长寿命、强环境适应等特点，涵盖纯电动面包车、电动清洗车、电动洗扫车、电动垃圾收运车等货运车型，零污染、零排放。',
  sanLunContent: '超电为电动两、三轮车提供绿色、智能、安全的超级快充系统应用解决方案，应用于快递、外卖、物流配送等场景，分分钟满电，全天候续航。',
  chenYongContent: '超电通过为乘用汽车提供超级快充、超高能比、超高功比、超长寿命的单体电芯，以及电池包设计和电能系统储存效率等方面不断革新，让整车充电“像加油一样！”，真正实现无忧续航。',
  elecMoContent: '超电通过革命性的超级快充技术，灵活的电芯配置方案以及智能化的BMS超级快充管理策略，让高速电摩客户在获得与世界级品牌同等加速度、续航和耐久的同时，享受全球领先的超级快充和超级安全。',
  elecContent: '超电根据金属切削、研磨、装配、铁道以及园林应用场景电动工具使用需求，提供充电快、耐宽温、长寿命、强劲动力的电池产品解决方案。',
  wuRenJiContent: '超电通过革命性的超级快充与智能化管控技术，带来40公斤的有效喷洒载重与50公斤的播撒载重，打造高效、便捷、智慧的农业新标杆。',

  channelInvestment: '渠道招商',
  businessCooperation: '企业合作',
  contactInformation: "联系方式",
  ext: "转",
  contact: '联系人',
  yuChao: '虞',
  caoYanJiang: '曹',

  zhaoPinTitle1: '在超电工作大有不同',
  zhaoPinTitle2: '一起做出激动人心的产品',
  zhaoPinTitle3:'与聪明人一起做事',

  zhaoPinContent1: '在超电，工作的氛围让每个人都积极创新，为做出美好的事情而努力。在这里没有大公司的等级观念，每个人都可以随时提出自己的创意和想法。',
  zhaoPinContent2: '让每个人都能享受科技的乐趣。超电公司推出全球首款800秒即可充满的移动电源——超电宝，确立石墨烯应用在移动电源领域领先地位！',
  zhaoPinContent3:'超电有着一流的互联网人才基因，2015年5月，投资成立江苏超电新能源，面向工业、军事和消费品等领域客户提供能源系统集成解决方案和技术支持服务',

  joinUs: '加入我们',
  jobTitle: '职位名称',
  jobCategories: '职位类别',
  numberOfRecruits: '招聘人数',
  workPlace: '工作地点',
  releaseDate: '发布日期',
  more: '更多',
  operate: '操作',
  check: '查看',

  recruitment: '招聘职位',
  monthlySalary: '月薪待遇',
  descriptionOfJob: '职位描述',
  workContent: '工作内容',
  companyBenefits: '公司福利',
  jobRequirements: '任职要求',

  address: "地址",
  phone: "电话",
  email: "邮箱",
  choseLanguage: '选择语言'
}
